<div class="title">
  <div class="title-close-button-wrapper">
    <i class="fal fa-times-circle cancelX" mat-button mat-dialog-close cdkFocusInitial></i>
  </div>
  <h2 class="mat-primary">{{ 'dashboard:Add to Dashboard' | i18next }}</h2>
</div>

<!--<div *ngIf="dashboardAccess; else message">-->
  <div class="dialog-content">
    <div class="relative-date-wrapper">
      <h3>{{ 'dashboard:Select Time Period' | i18next }}</h3>
      <label>{{ 'dashboard:From' | i18next }}</label>
      <app-relative-date-select class="grow" [gridItem]="gridItem" model="from" [reportMaxDays]="report?.dataAvailableFor" (addToDashboardChange)="onFromTimeChange()" [isExportDialog]="true"></app-relative-date-select>
      <br />
      <label>{{ 'dashboard:To' | i18next }}</label>
      <app-relative-date-select class="grow" [gridItem]="gridItem" model="to" [reportMaxDays]="report?.dataAvailableFor" [notifier]="notifier"></app-relative-date-select>
    </div>
    <div>
      <h3>{{'dashboard:Dashboard Selection' | i18next}}</h3>
      <div>
        <label>{{'dashboard:Widget title' | i18next}}</label>
        <app-widget-textbox [(model)]="widgetTitle" textboxWidth="100%" placeholder="{{'dashboard:Type widget title here' | i18next}}..."></app-widget-textbox>
      </div>
      <br />
      <div>
        <mat-radio-group role="radiogroup" class="mat-radio-group add-or-create-radios" [(ngModel)]="type">
          <mat-radio-button class="mat-radio-button redRadio" [value]="0">
            <span class="radio-lable">{{ 'dashboard:Add to Existing Dashboard' | i18next }}:</span>
          </mat-radio-button><br />
          <ng-select [(ngModel)]="selectedDashboardId" [loading]="dashboardsLoading" [disabled]="type === 1" [placeholder]="ngSelectPlaceholder">
            <ng-option *ngFor="let dashboard of ownDashboards" [value]="dashboard.id">{{ dashboard.name }}</ng-option>
          </ng-select>
          <mat-radio-button class="mat-radio-button redRadio {{ allowNewDashboardCreation ? '' : 'disabled-opacity' }}" [value]="1" [disabled]="!allowNewDashboardCreation">
            <span class="radio-lable">{{ 'dashboard:Create New Dashboard' | i18next }}:</span>
          </mat-radio-button>
          <app-widget-textbox [(model)]="newDashboardName" textboxWidth="100%" placeholder="{{ 'dashboard:Type dashboard name' | i18next }}..."
                              [disabled]="type === 0" [class]="type === 0 ? 'disabled-opacity' : ''"></app-widget-textbox>
        </mat-radio-group>
      </div>
      <div class="permission-settings-wrapper {{ type === 0 ? 'disabled-opacity' : '' }}">
        <label>{{ 'dashboard:Visibility Permissions' | i18next }}:</label>
        <mat-radio-group role="radiogroup" class="mat-radio-group permission-settings-radios" [(ngModel)]="isPublic" [disabled]="type === 0">
          <mat-radio-button class="mat-radio-button redRadio" [value]="false">
            <span class="radio-lable">{{ 'dashboard:Private' | i18next }}</span>
          </mat-radio-button>
          <mat-radio-button class="mat-radio-button redRadio" [value]="true">
            <span class="radio-lable">{{ 'dashboard:Company' | i18next }}</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>

  <mat-dialog-actions style="justify-content: space-between;">
    <button mat-flat-button mat-dialog-close class="secondary-button">{{ 'translation:Cancel' | i18next }}</button>
    <button mat-flat-button [disabled]="!canExport" (click)="addButtonClick()" class="primary-button">{{ 'translation:Add' | i18next }}</button>
    <button mat-flat-button [disabled]="!canExport" (click)="addAndSeeDashboardButtonClick($event)" class="primary-button">{{ 'translation:Add and see Dashboard' | i18next }}</button>
  </mat-dialog-actions>
<!--</div>

<ng-template #message>
  <div class="message">
    {{ 'dashboard:You can not select Add to Dashboard since you do not have access to the Dashboard page' | i18next }}
  </div>
</ng-template>-->
